import { useCallback, useEffect, useRef, useState } from "react";

export const STAGES = ["unmeasured", "measured", "explained"];
const reduced = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export const useMistSequence = () => {
  const [stage, setStage] = useState(() => (reduced() ? "explained" : "unmeasured"));
  const [scan, setScan] = useState(false);
  const timers = useRef([]);

  const clear = useCallback(() => {
    timers.current.forEach(clearTimeout);
    timers.current = [];
  }, []);

  const play = useCallback(() => {
    clear();
    if (reduced()) {
      setStage("explained");
      return;
    }
    setStage("unmeasured");
    setScan(false);
    const t = (fn, ms) => timers.current.push(setTimeout(fn, ms));
    t(() => { setScan(true); setStage("measured"); }, 1400);
    t(() => setStage("explained"), 4200);
    t(() => setScan(false), 4400);
  }, [clear]);

  useEffect(() => {
    const id = setTimeout(play, 500);
    return () => { clearTimeout(id); clear(); };
  }, [play, clear]);

  return { stage, stageIndex: STAGES.indexOf(stage), scan, play };
};
